import { AsyncAction } from "@/Common/Api/AsyncActions/AsyncAction";
import * as ServerOperations from "@/Common/Operations/operations.server";

class MedicalNotePopupAction extends AsyncAction {
    public async cancelEncounterAutoApprove(encounterId: string, hideAutoApproveWarningPopup?: boolean, consultationContextLookupId?: string): Promise<void> {
        await this.postAsync(ServerOperations.Server.Myle_Patient_MedicalNote_CancelAutoApprove, {
            EncounterId: encounterId,
            HideAutoApproveWarningPopup: hideAutoApproveWarningPopup,
            ConsultationContextLookupId: consultationContextLookupId
        });
    }
}

export { MedicalNotePopupAction };
